// Landing Page Data Context
import React, { createContext, useContext } from 'react';

const LandingPageContext = createContext(null);

// Default data for pages outside LandingPageProvider (like Blog)
const defaultData = {
  clinicInfo: {
    name: 'Dion Hair Clinic',
    phone: '+49 2161 2963017',
    email: 'info@dionhairclinic.de',
    address: {
      street: 'Schürenweg 61',
      city: 'Mönchengladbach',
      zip: '41063',
      country: 'Deutschland'
    },
    openingHours: {
      weekdays: 'Mo-Fr: 09:00 - 18:00',
      saturday: 'Sa-So: Geschlossen'
    },
    social: {
      instagram: 'https://www.instagram.com/dionhairclinic',
      youtube: 'https://www.youtube.com/@dionhairclinic'
    }
  },
  features: {
    showAIAnalysis: false
  }
};

export const useLandingPageData = () => {
  const context = useContext(LandingPageContext);
  // Return default data if used outside provider (e.g., on blog pages)
  if (!context) {
    return defaultData;
  }
  return context;
};

export const LandingPageProvider = ({ data, children }) => {
  return (
    <LandingPageContext.Provider value={data}>
      {children}
    </LandingPageContext.Provider>
  );
};

export default LandingPageContext;
